import * as type from "./constants";

const initialState = {
  unreadNotifications: 0
};

const reducer = (state = initialState, action: any) => {
  switch (action.type) {
    case type.SET_UNREAD_NOTIFICATIONS: {
      return {
        ...state,
        unreadNotifications: action.count
      };
    }
    default: {
      return state;
    }
  }
};

export default reducer;
